















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CapPrintVue from "./CapPrint.vue";
import { Income } from "../../data/incomeData";
import ReportMarginVue from "./ReportMargin.vue";
import AccountingSystem from "@/data/AccountingSystem";
@Component({
	components: {
		cap: CapPrintVue,
		"report-margin": ReportMarginVue,
	},
})
export default class IncomePrint extends Vue {
	@Prop({ type: Array })
	dataList!: any[];

	@Prop({ type: String })
	period!: string;

	@Prop({ type: String })
	fontSize!: string;

	margin: number = this.$store.state.sheet.top;
	padding: number = this.$store.state.sheet.left;

	accountBook: AccountBookList.AccountBook = this.$store.state.accountBook;

	get accountingSystem() {
		return this.accountBook.accountingSystem ===
			AccountingSystem.thirteenRule ||
			this.accountBook.accountingSystem === AccountingSystem.nineteenRule
			? true
			: false;
	}

	mounted() {
		console.log(this.period, "period")
	}
}
